export default "__VITE_ASSET__CA2Bx3Nw__"